import { Col, Row } from 'antd';
import React, { useEffect, useMemo } from 'react';
import AccountActivationTable from './AccountActivationTable';
import DeviceActivationTable from './DeviceActivationTable';
import LicenseCheckSection from './LicenseCheckSection';
import NamespaceActivationTable from './NamespaceActivationTable';
import SingleServiceActivationResult from './SingleServiceActivationResult';

const ActivationTab = ({
  form,
  onCheckCode,
  license,
  licenseInfo,
  service,
  rowSelection,
  rowSelectionAccount,
  dataNamespace,
  devices,
  accounts,
  handleTableChange,
  isLoadActiveLicenseNamespace,
  isLoadActiveLicense,
  isLoadActiveLicenseAccount,
  onDeactivateNameSpace,
  singleActiveNamespace,
  onDeactivateDevice,
  singleActiveDevice,
  onDeactivateAccount,
  singleActiveAccount,
  syncLoading,
  syncActivateDevice,
  syncActivateAccount,
  activateChain,
  activateChainAccount,
}) => {
  const isTargetBased = useMemo(() => service &&
    (service.activeType?.includes('per_device') ||
      service.activeType?.includes('per_account') ||
      service.activeType?.includes('per_namespace')),
    [service])

  return (
    <Row gutter={16} style={{ marginLeft: '0px' }}>
      <LicenseCheckSection
        form={form}
        onCheckCode={onCheckCode}
        license={license}
        licenseInfo={licenseInfo}
        service={service}
      />
      <Col span={18}>
        {isTargetBased ? (
          service.activeType?.includes('per_namespace') ? (
            <NamespaceActivationTable
              rowSelection={rowSelection}
              dataNamespace={dataNamespace}
              handleTableChange={handleTableChange}
              isLoadActiveLicenseNamespace={isLoadActiveLicenseNamespace}
              license={license}
              onDeactivateNameSpace={onDeactivateNameSpace}
              singleActiveNamespace={singleActiveNamespace}
            />
          ) : service.activeType?.includes('per_device') ? (
            <DeviceActivationTable
              devices={devices}
              rowSelection={rowSelection}
              handleTableChange={handleTableChange}
              isLoadActiveLicense={isLoadActiveLicense}
              license={license}
              onDeactivateDevice={onDeactivateDevice}
              singleActiveDevice={singleActiveDevice}
              syncLoading={syncLoading}
              syncActivateDevice={syncActivateDevice}
              activateChain={activateChain}
            />
          ) : (
            <AccountActivationTable
              accounts={accounts}
              rowSelectionAccount={rowSelectionAccount}
              handleTableChange={handleTableChange}
              isLoadActiveLicenseAccount={isLoadActiveLicenseAccount}
              license={license}
              onDeactivateAccount={onDeactivateAccount}
              singleActiveAccount={singleActiveAccount}
              syncLoading={syncLoading}
              syncActivateAccount={syncActivateAccount}
              activateChainAccount={activateChainAccount}
            />
          )
        ) : (
          <SingleServiceActivationResult
            service={service}
            license={license}
          />
        )}
      </Col>
    </Row>
  );
};

export default ActivationTab;
